
import Vue from 'vue';

const $axios = Vue.axios;

export default {
	namespaced: true,
	state: {
		sendMailLoading: false,
		sendMailError: null,
		lastMailResponse: null,
	},
	mutations: {
		SET_SEND_MAIL_LOADING(state, loading) {
			state.sendMailLoading = loading;
		},
		SET_SEND_MAIL_ERROR(state, error) {
			state.sendMailError = error;
		},
		SET_LAST_MAIL_RESPONSE(state, response) {
			state.lastMailResponse = response;
		},
	},
	actions: {
		async sendPbcMail({ commit }, { id, data }) {
			commit('SET_SEND_MAIL_LOADING', true);
			commit('SET_SEND_MAIL_ERROR', null);
			try {
				const response = await $axios.post(`/v2/financialclose/pbc/request/sendmail/${id}`, { data });
				commit('SET_LAST_MAIL_RESPONSE', response.data);
				return response;
			} catch (error) {
				commit('SET_SEND_MAIL_ERROR', error.message || error || 'Unknown error!');
				throw error;
			} finally {
				commit('SET_SEND_MAIL_LOADING', false);
			}
		},
	},
	getters: {
	},
};
